import { toJalaali } from "jalaali-js";

export const SmsCampaignStatus = {
  Pending: 0,
  Sending: 1,
  Completed: 2,
  Cancelled: 3,
};

export const SmsQueueStatus = {
  Pending: 0,
  Sent: 1,
  Failed: 2,
  Cancelled: 3,
  Sending: 4,
};

export const isSmsCampaignEditable = (campaign) => {
  if (campaign?.status === SmsCampaignStatus.Pending) return true;
  if (campaign?.status !== SmsCampaignStatus.Cancelled) return false;

  const counts = campaign.counts || campaign;
  return (
    !Number(counts.sent || 0) &&
    !Number(counts.failed || 0) &&
    !Number(counts.sending || 0) &&
    (!campaign.queues ||
      campaign.queues.every((queue) => queue.status === SmsQueueStatus.Cancelled))
  );
};

const campaignStatusLabels = {
  [SmsCampaignStatus.Pending]: "در انتظار",
  [SmsCampaignStatus.Sending]: "در حال ارسال",
  [SmsCampaignStatus.Completed]: "تکمیل‌شده",
  [SmsCampaignStatus.Cancelled]: "لغوشده",
};

const campaignStatusColors = {
  [SmsCampaignStatus.Pending]: "gold",
  [SmsCampaignStatus.Sending]: "blue",
  [SmsCampaignStatus.Completed]: "green",
  [SmsCampaignStatus.Cancelled]: "default",
};

const queueStatusLabels = {
  [SmsQueueStatus.Pending]: "در انتظار",
  [SmsQueueStatus.Sending]: "در حال ارسال",
  [SmsQueueStatus.Sent]: "ارسال‌شده",
  [SmsQueueStatus.Failed]: "ناموفق",
  [SmsQueueStatus.Cancelled]: "لغوشده",
};

const queueStatusColors = {
  [SmsQueueStatus.Pending]: "gold",
  [SmsQueueStatus.Sending]: "blue",
  [SmsQueueStatus.Sent]: "green",
  [SmsQueueStatus.Failed]: "red",
  [SmsQueueStatus.Cancelled]: "default",
};

export const campaignStatusLabel = (status) =>
  campaignStatusLabels[status] || "نامشخص";

export const campaignStatusColor = (status) =>
  campaignStatusColors[status] || "default";

export const queueStatusLabel = (status) =>
  queueStatusLabels[status] || "نامشخص";

export const queueStatusColor = (status) =>
  queueStatusColors[status] || "default";

export const formatJalaliDateTime = (value) => {
  if (!value || value === "-") return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  const jalali = toJalaali(
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate()
  );
  return `${jalali.jy}-${jalali.jm}-${jalali.jd} ${date.toLocaleTimeString("eo", {
    hour12: false,
  })}`;
};

export const formatCampaignSendAt = (value) => {
  if (!value) return "اولین فرصت";
  return formatJalaliDateTime(value);
};

export const countRecipientTokens = (value) =>
  String(value || "")
    .split(/[\s,;،]+/)
    .map((part) => part.trim())
    .filter(Boolean).length;
